import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Applicant from "./applicant";
import * as FieldComponents from "@Shared/components/sections/index";
import DuplicatorMixin from "@Shared/utils/application-mixins/duplicator-mixin";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import { ADD_APPLICATION_GROUP, REMOVE_APPLICATION_GROUP } from "../../../store/application-actions";
import { getFullNameWithSalutationFrom } from "@Shared/utils/utils";
import { mapActions } from "vuex";
import { startCase } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CoApplicants",
  components: _objectSpread(_objectSpread({
    Applicant
  }, FieldComponents), {}, {
    InlinePrompt
  }),
  mixins: [DuplicatorMixin],
  props: {
    currentApplication: {
      type: Object,
      required: true
    },
    clientUsername: {
      required: true,
      validator: prop => typeof prop === "string" || prop === null
    },
    applicationId: {
      required: true,
      validator: prop => typeof prop === "number" || prop === null
    },
    editVisibility: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    coApplicants() {
      return this.currentApplication["co-applicants"];
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationStore", [ADD_APPLICATION_GROUP, REMOVE_APPLICATION_GROUP])), {}, {
    handleSave() {
      this.$emit("save");
    },
    handleDuplicate({
      what: coappSkeleton,
      where
    }) {
      var _this$currentApplicat, _this$currentApplicat2, _this$currentApplicat3, _this$currentApplicat4;
      const mainAppLanguage = (_this$currentApplicat = (_this$currentApplicat2 = this.currentApplication) == null ? void 0 : (_this$currentApplicat3 = _this$currentApplicat2["main-applicant"]) == null ? void 0 : (_this$currentApplicat4 = _this$currentApplicat3["personal-details"]) == null ? void 0 : _this$currentApplicat4["language-preference"]) != null ? _this$currentApplicat : "";
      coappSkeleton["personal-details"]["language-preference"] = `${mainAppLanguage}`;
      this.ADD_APPLICATION_GROUP({
        what: coappSkeleton,
        where
      });
      this.$emit("save");
    },
    handleVisibility(data) {
      this.$emit("toggle-visibility", data);
    },
    handleRemove(index, removePath) {
      this.REMOVE_APPLICATION_GROUP({
        index,
        where: removePath
      });
      this.$emit("save");
    },
    coApplicantName(index) {
      const {
        "personal-details": personalDetails
      } = this.currentApplication["co-applicants"][index];
      return getFullNameWithSalutationFrom(personalDetails);
    },
    hasFirstName(index) {
      const {
        "first-name": firstName
      } = this.currentApplication["co-applicants"][index]["personal-details"];
      return !!firstName;
    },
    getCoApplicantType(index) {
      const {
        "co-applicant-type": coApplicantType
      } = this.currentApplication["co-applicants"][index]["personal-details"];
      return coApplicantType && startCase(coApplicantType);
    }
  })
});